import { 
    GET_QR_LIST, 
    SET_QR, 
    REMOVE_QR, 
    GET_EQUIPMENT_LIST,
    SET_FILTER_EQUIPMENT_TYPE,
    SET_EQU_FILTER,
    GET_CATEGORIES
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    allQR: false,
    posting: false,
    allEquipment: false,
    equType: "all_categories",
    equFilter: false,
    category: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CATEGORIES.REQUEST: {
            return { ...state, requesting: true, category: false };
        }
        case GET_CATEGORIES.FAIL: {
            return { ...state, requesting: false, category: false };
        }
        case GET_CATEGORIES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                category: action.payload
            };
        }
        case GET_QR_LIST.REQUEST: {
            return { ...state, requesting: true, allQR: false };
        }
        case GET_QR_LIST.FAIL: {
            return { ...state, requesting: false, allQR: false };
        }
        case GET_QR_LIST.SUCCESS: {
            return {
                ...state,
                requesting: false,
                allQR: action.payload
            };
        }
        case GET_EQUIPMENT_LIST.REQUEST: {
            return { ...state, requesting: true, allEquipment: false };
        }
        case GET_EQUIPMENT_LIST.FAIL: {
            return { ...state, requesting: false, allEquipment: false };
        }
        case GET_EQUIPMENT_LIST.SUCCESS: {
            return {
                ...state,
                requesting: false,
                allEquipment: action.payload
            };
            
        }
        case SET_QR.REQUEST: {
            return { ...state, requesting: true, posting: true };
        }
        case SET_QR.FAIL: {
            return { ...state, requesting: false, posting: false };
        }
        case SET_QR.SUCCESS: {
            return { ...state, requesting: false, posting: false };
        }
        case REMOVE_QR.REQUEST: {
            return { ...state, requesting: true, posting: true };
        }
        case REMOVE_QR.FAIL: {
            return { ...state, requesting: false, posting: false };
        }
        case REMOVE_QR.SUCCESS: {
            return { ...state, requesting: false, posting: false };
        }
        case SET_FILTER_EQUIPMENT_TYPE: {
            return { ...state, equType: action.payload };
        }
        case SET_EQU_FILTER: {
            return { ...state, equFilter: action.payload };
        }
        default: {
            return state;
        }
    }
};
